export const ATTENDEES_LIMIT_PER_PAGE = 20;
export const NO_ACTIVE_ATTENDESS_MESSAGE = 'There are no Active Attendees';
export const INTERVAL = 5000;
export const NO_RESULTS = 'No results';
export const NO_RESULTS_FOUND = 'No results found';

export const NO_DEPARTURE = '.................';

export const NO_ATTENDESS_MESSAGE_MAP: { [key: string]: string } = {
  'ACTIVE': NO_ACTIVE_ATTENDESS_MESSAGE,
  'DEPARTED': NO_RESULTS_FOUND,
  'DISCONNECTED&DISCONNECTING': NO_RESULTS_FOUND
};
